import { render, staticRenderFns } from "./socialResponsibility.vue?vue&type=template&id=52d5d793&scoped=true&"
import script from "./socialResponsibility.vue?vue&type=script&lang=js&"
export * from "./socialResponsibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d5d793",
  null
  
)

export default component.exports